import { IWaypoint } from '@src/pages/DeliveryDashboard/models/model-interface';
import HttpClient from '@src/shared/services/base/http-client';
export interface IGetCalcutateDirectionParams {
  origin: any;
  destination: IWaypoint;
  waypoints: Array<IWaypoint>;
  travelMode: string;
}
export type TGetCalculatedDirection = (
  params: IGetCalcutateDirectionParams
) => Promise<any>;

class GoogleMapsRoutesApiService extends HttpClient {
  constructor(
    baseURL: string,
    authHeaderName: string,
    predefinedToken: string
  ) {
    super(baseURL, authHeaderName, false, predefinedToken);
    this.addHeader(
      'X-Goog-FieldMask',
      'routes.duration,routes.distanceMeters,routes.legs'
    );
  }

  public getCalculatedDirection: TGetCalculatedDirection = ({
    origin,
    destination,
    waypoints,
    travelMode = 'BICYCLE',
  }) => {
    const intermediates = waypoints.map((wp: IWaypoint) => {
      return {
        location: {
          latLng: {
            latitude: wp.location.latitude,
            longitude: wp.location.longitude,
          },
        },
      };
    });

    const requestData: any = {
      origin: {
        location: {
          latLng: {
            latitude: origin?.latitude,
            longitude: origin?.longitude,
          },
        },
        sideOfRoad: travelMode === 'DRIVE' ? true : false,
      },
      destination: {
        location: {
          latLng: {
            latitude: destination.location.latitude,
            longitude: destination.location.longitude,
          },
        },
      },
      intermediates,
      travelMode,
      computeAlternativeRoutes: true,
      routeModifiers: {
        avoidTolls: false,
        avoidHighways: false,
        avoidFerries: false,
      },
      languageCode: 'en-US',
      units: 'IMPERIAL',
    };

    if (travelMode === google.maps.TravelMode.DRIVING) {
      requestData['routingPreference'] = 'TRAFFIC_AWARE';
    }

    return this.instance.post(`directions/v2:computeRoutes`, requestData);
  };
}

export default new GoogleMapsRoutesApiService(
  'https://routes.googleapis.com/',
  'X-Goog-Api-Key',
  process.env.GOOGLE_MAPS_API_KEY || ''
);
